<template>
  <router-link :to="link" class="logo">
    <img src="~@/assets/logo.png" alt="JAND logo">
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Logo',
  computed: {
    ...mapGetters(['getMode']),
    link() {
      const homeLink = {
        reader: {
          name: 'Home',
        },
        admin: {
          name: 'CalendarMonth',
        },
      };
      return homeLink[this.getMode];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.logo {
  img {
    height: 50px;
  }
}
</style>
